import React from 'react';
import {
    Container,
    Typography,
    Box,
    Grid,
    Card,
    CardContent,
    Avatar,
    alpha,
    useTheme
} from '@mui/material';
import {
    People as PeopleIcon,
    Dashboard as DashboardIcon,
    Class as ClassIcon,
    Assignment as AssignmentIcon,
    Message as MessageIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const AffiliateOwnerPage = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const pricingPlan = localStorage.getItem('pricingPlan');

    // Quick action cards data
    const quickActions = [
        { 
            title: 'My Affiliate', 
            icon: <DashboardIcon />, 
            path: '/my-affiliate',
            color: '#1976d2',
            description: 'Manage your gym settings'
        },
        { 
            title: 'Classes', 
            icon: <ClassIcon />, 
            path: '/classes',
            color: '#2e7d32',
            description: 'Schedule & manage classes'
        },
        { 
            title: 'Members', 
            icon: <PeopleIcon />, 
            path: '/members',
            color: '#ed6c02',
            description: 'View all members'
        },
        { 
            title: 'Plans', 
            icon: <AssignmentIcon />, 
            path: '/plans',
            color: '#9c27b0',
            description: 'Manage membership plans'
        },
        ...(pricingPlan === 'premium'
            ? [{
                title: 'Messages',
                icon: <MessageIcon />,
                path: '/messages',
                color: '#0288d1',
                description: 'Send messages to members'
            }]
            : [])
    ];

    // Quick action card component
    const QuickActionCard = ({ title, icon, path, color, description }) => (
        <Card 
            elevation={1}
            sx={{ 
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4,
                    bgcolor: alpha(color, 0.05)
                }
            }}
            onClick={() => navigate(path)}
        >
            <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <Avatar sx={{ bgcolor: alpha(color, 0.1), color, mr: 2 }}>
                        {icon}
                    </Avatar>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {title}
                    </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </CardContent>
        </Card>
    );

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }}>
            {/* Welcome Header */}
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                    Welcome back! 👋
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Choose an action to get started
                </Typography>
            </Box>

            {/* Quick Actions */}
            <Grid container spacing={3}>
                {quickActions.map((action, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <QuickActionCard {...action} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default AffiliateOwnerPage;
